module.exports = __webpack_public_path__ + "images/adriaanse_small2329152aa45ea890f276471e032d44f1.png";